import { Divider, Grid } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import moment from "moment";
import { useFormatPrice } from "hooks";

const Footer = ({ value }) => {
  const formatPrice = useFormatPrice();
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    if (value && value.id && value.payments.length > 0) {
      var _payment = value.payments
        .map((p) => p.amount)
        .reduce((x, y) => x + y, 0);
      setBalance(value.netPayable - _payment);
    } else setBalance(value.netPayable);
    return () => {};
  }, [value]);

  const renderPriceRow = (label, amount, className) => (
    <div className={`flex justify-between items-center ${className}`}>
      <span>{label}</span>
      <span> {formatPrice(amount)}</span>
    </div>
  );

  return value && value.id ? (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        {value.note && (
          <div className="grid gap-[10px]">
            <span className="text-[12px] font-medium text-gray-500">
              Note:{" "}
            </span>
            <span>{value.note}</span>
          </div>
        )}
      </Grid>
      <Grid item xs={12} md={7}>
        <div className="flex flex-col gap-1 text-gray-500">
          {renderPriceRow("Subtotal", value.subtotal)}
          {renderPriceRow(
            `Total tax (${value.taxRate || 0}%) (+)`,
            value.taxAmt
          )}
          {renderPriceRow("Discount on total (-)", value.disAmt)}
          <Divider />
          {renderPriceRow(
            "Sale total",
            value.netPayable,
            "uppercase font-bold"
          )}
          <Divider />
          {/* -------- Payments -------- */}
          {value.payments.map((p, index) => (
            <Fragment key={index}>
              {renderPriceRow(
                `${p.payType?.name} | ${moment(p.createDate).format(
                  "ddd, MMM D, YYYY, h:mm A"
                )}`,
                p.amount,
                "text-[14px]"
              )}
            </Fragment>
          ))}
          {value.payments.length > 0 && <Divider />}
          {renderPriceRow(
            balance > 0 ? "Balance" : "Change",
            Math.abs(balance),
            `uppercase font-bold ${
              balance > 0 ? "!text-red-500" : "text-gray-500"
            }`
          )}
        </div>
      </Grid>
    </Grid>
  ) : (
    "null"
  );
};

export default Footer;
